<template>
  <div class="performance">
    <router-link
      :to="{
        name: 'performance',
        params: { performanceId: performance.id }
      }"
      @click.native="getProducts(performance.id)"
    >
      <span class="performance-date">{{
        performance.startDate | formatDate
      }}</span>
      <span class="performance-time"
        >@{{ performance.startDateTime | formatTime }}</span
      >
    </router-link>
    <div
      v-if="performanceId == performance.id"
      class="products loader-container"
    >
      <b-tabs nav-class="roduct-name" content-class="product" justified pills>
        <b-tab
          v-for="product in performanceProducts"
          :key="product.id"
          :title="product.name"
          :active="productId == product.id"
          class="product"
        >
          <Product :product="product"></Product>
        </b-tab>
      </b-tabs>
      <div v-if="noProducts">No Products</div>
      <Loader :loading="loadingProducts" />
    </div>
  </div>
</template>
<script>
import Service from '@/services/Service.js';
import Product from '@/components/Product.vue';
import Loader from '@/components/Loader.vue';
export default {
  components: { Product, Loader },
  props: {
    performance: { type: Object, default: null },
    performanceId: { type: String, default: null },
    productId: { type: String, default: null }
  },
  data: function() {
    return {
      performanceProducts: [],
      noProducts: false,
      loadingProducts: false
    };
  },
  created() {
    if (this.performanceId == this.performance.id) {
      this.getProducts(this.performanceId);
    }
  },
  methods: {
    getProducts(performanceId) {
      this.loadingProducts = true;
      Service.getPerformanceProducts(performanceId).then(response => {
        this.performanceProducts = response.data;
        this.loadingProducts = false;
        this.noProducts = this.performanceProducts.length == 0;
      });
    }
  }
};
</script>
